import React from "react";


class RippleButton extends React.Component {
    state = {
        isFocuced: false
    }




    rippleHover = (event) => {
        // console.log(event)
        // element.appendChild('<div class="TEST"></div>')

        var notes = this.buttonBack;

        let rect = this.button.getBoundingClientRect()
        let top = event.clientY - rect.top
        let left = event.clientX - rect.left

        // console.log(rect.top)
        // console.log(event.clientY)
        if (notes) {
            notes.style.top = top + 'px'
            notes.style.left = left + 'px'
            notes.style.transition = ' width 1s, height 1s'
            // notes.style.transform = 'translate(-50%,-50%)'
            // notes.style.width = "500px"

            notes.style.width = "1200px"
            notes.style.height = "1200px"
            notes.style.background = this.props.color??"#F87C56"


        }

    }

    rippleOut = (event) => {
        // console.log(event)
        // element.appendChild('<div class="TEST"></div>')

        var notes = this.buttonBack;


        let rect = this.button.getBoundingClientRect()
        let top = event.clientY - rect.top
        let left = event.clientX - rect.left

        if (notes) {
            notes.style.transition = ' width 0.5s, height 0.5s'

            notes.style.top = top + 'px'
            notes.style.left = left + 'px'

            notes.style.width = "0px"
            notes.style.height = "0px"
            // notes.style.background = "transparent"


        }

    }


    render() {

        return (
            <button onClick={()=>{if(this.props.onClick)this.props.onClick()}} ref={el => this.button = el} className="ripple-but" onMouseEnter={e => this.rippleHover(e)} onMouseLeave={e => this.rippleOut(e)}  style={{borderWidth:1, borderColor:this.props.color??"#F87C56",color:this.props.color??"#F87C56"}}>
                <div ref={el => this.buttonBack = el} className="ripple-back"></div>
                <span className="position-relative text-small transition-all " style={{whiteSpace:'nowrap'}}>{this.props.label}</span>
                {/* style={{ backgroundColor: '#F87C56', padding: '10px 15px', color: '#fff', textAlign: 'center', width: '100%', borderRadius: 8, fontSize: 16 }} */}
            </button>

        )
    }
}






export default RippleButton;
